import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectConfig, selectContactComments } from '../../../SubscriptionForm/SubscriptionFormSelectors'
import { subscriptionFormActionsV2 } from '../../../SubscriptionForm/SubscriptionFormV2Sagas'
import { addCommentToContact } from '../../../SubscriptionForm/SubscriptionFormSlice'

const useComments = () => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const { contactId } = useSelector(selectConfig)
  const comments = useSelector(selectContactComments)

  const handleSubmit = (comment, callback) => {
    dispatch({
      type: subscriptionFormActionsV2.ADD_COMMENT_TO_CONTACT_V2,
      comment,
      contactId,
      callback: (response, status) => {
        const success = status === 200 && response?.success
        if (success) {
          dispatch(addCommentToContact(response))
        }
        callback(success)
      },
    })
  }

  return {
    isOpen,
    setIsOpen,
    comments,
    handleSubmit,
  }
}

export default useComments
